export enum UserOrgTypesEnum {
  KNO = 'KNO',
  PROSECUTOR = 'PROSECUTOR',
}
